import { lazy } from 'react';

const Login = lazy(() => import('./login'));
const ResetPassword = lazy(() => import('./reset-password'));
const SendResetPassword = lazy(() => import('./send-reset-password'));

export { Login, ResetPassword, SendResetPassword };
